import Axios from 'axios';

import cookies from 'utils/cookies';
import { getToken } from 'apis/authAPI';
import { API_URL, WORKFLOW_API_URL } from 'apis/apiConfig';

const onLogout = () => {
	// Clear the user token from cookies
	cookies.clearAccessToken();
	cookies.clearRefreshToken();

	// Redirect to the sign-in page
	window.location = '/signin';
};

export const axiosClient = Axios.create({
	baseURL: API_URL,
	// withCredentials: true,
});

export const axiosPublic = Axios.create({
	baseURL: API_URL,
});

export const axiosWorkflow = Axios.create({
	baseURL: WORKFLOW_API_URL,
});

axiosPublic.interceptors.response.use(
	response => {
		return response.data;
	},
	async error => {
		return Promise.reject(error);
	}
);

const requestIntercept = axiosClient.interceptors.request.use(
	config => {
		const token = cookies.getAccessToken();
		if (token) {
			config.headers.authorization = `Bearer ${token}`;
		}
		config.headers.Accept = 'application/json';
		return config;
	},
	error => Promise.reject(error),
	{ synchronous: true }
);

const responseIntercept = axiosClient.interceptors.response.use(
	response => {
		return response.data;
	},
	async error => {
		const prevRequest = error?.config;

		if (error?.response?.status === 401 && !prevRequest?.sent) {
			prevRequest.sent = true;

			try {
				// Token expired, attempt refresh
				const tokens = await getToken();
				const newAccessToken = tokens.access.token;

				cookies.setAccessToken(tokens.access.token);
				cookies.setRefreshToken(tokens.refresh.token);

				// Retry the failed request with the new access token
				prevRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;

				return axiosClient(prevRequest);
			} catch (refreshError) {
				// Can logout the user or redirect to a login page
				// onLogout();
				throw refreshError;
			}
		}
		return Promise.reject(error);
	},
	{ synchronous: true }
);

const requestWorkflowIntercept = axiosWorkflow.interceptors.request.use(
	config => {
		const token = cookies.getAccessToken();
		if (token) {
			config.headers.authorization = `Bearer ${token}`;
		}
		config.headers.Accept = 'application/json';

		return config;
	},
	error => Promise.reject(error),
	{ synchronous: true }
);

const responseWorkflowIntercept = axiosWorkflow.interceptors.response.use(
	response => {
		return response.data;
	},
	async error => {
		const prevRequest = error?.config;

		if (error?.response?.status === 401 && !prevRequest?.sent) {
			prevRequest.sent = true;

			try {
				// Token expired, attempt refresh
				const tokens = await getToken();
				const newAccessToken = tokens.access.token;

				cookies.setAccessToken(tokens.access.token);
				cookies.setRefreshToken(tokens.refresh.token);

				// Retry the failed request with the new access token
				prevRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
				return axiosWorkflow(prevRequest);
			} catch (refreshError) {
				// Can logout the user or redirect to a login page
				onLogout();
				throw refreshError;
			}
		}
		return Promise.reject(error);
	},
	{ synchronous: true }
);
